import { ErrorBoundary } from "react-error-boundary";
import { Navigate } from "react-router-dom";

import { useUserInfoQuery } from "Auth/Api/Queries/useUserInfoQuery";
import { ApplicationErrorPage } from "Infrastructure/Pages/ApplicationErrorPage";
import { AppRouting } from "Infrastructure/Utils/UrlUtils";

type Props = {};

export const UnauthenticatedRoute: React.FC<React.PropsWithChildren<Props>> = ({
	children,
}) => {
	const { data, isLoading } = useUserInfoQuery();

	if (isLoading) return <div />;

	if (data?.status === 200) {
		return <Navigate to={AppRouting.Home.path()} replace />;
	}

	return (
		<ErrorBoundary FallbackComponent={ApplicationErrorPage}>
			{children}
		</ErrorBoundary>
	);
};
